import { makeStyles } from "@mui/styles";
import { COLORS } from "components/v3/Theme/colors";

const ArticleStyles = makeStyles((theme) => ({
  container: {},
  articleContainer: {
    padding: "0px 20px 100px",
    paddingRight: "6rem",
    [theme.breakpoints.down("lg")]: {
      paddingRight: "2rem"
    },
    color: COLORS.DARK_GRAY_2,
    fontSize: "1.15rem",
    lineHeight: "1.65rem",
    fontFamily: "Inter, sans-serif",
    "& ul": { "padding-inline-start": "30px" },
    "& li": {
      paddingBottom: 15,
      "&::marker": { fontSize: 26 },
      "& a": {
        color: COLORS.ACCENT2,
        position: "relative",
        top: -2
      }
    },
    "& a": {
      color: COLORS.ACCENT2
    },
    "& img": { width: "100%", height: "auto" }
  }
}));

export default ArticleStyles;
